// import ana1 from '/assets/artists/ana/ana1.jpg'
// import camilo1 from '/assets/artists/camilo/camilo1.jpg'
// import clara1 from '/assets/artists/clara/clara1.jpg'
// import daniel1 from '/assets/artists/daniel/daniel1.jpg'
// import edna1 from '/assets/artists/edna/edna1.jpg'
// import filipe1 from '/assets/artists/filipe/filipe1.jpg'
// import isabela1 from '/assets/artists/isabela/isabela1.jpg'
// import jessica1 from '/assets/artists/jessica/jessica1.jpg'
// import juliana1 from '/assets/artists/juliana/juliana1.jpg'
// import larissa1 from '/assets/artists/larissa/larissa1.jpg'
// import mariajulia1 from '/assets/artists/mariajulia/mariajulia1.jpg'
// import mauricio1 from '/assets/artists/mauricio/mauricio1.jpg'
// import mayra1 from '/assets/artists/mayra/mayra1.jpg'
// import philippe1 from '/assets/artists/philippe/philippe1.jpg'
// import regi1 from '/assets/artists/regi/regi1.jpg'
// import renato1 from '/assets/artists/renato/renato1.jpg'
// import rinaldo1 from '/assets/artists/rinaldo/rinaldo1.jpg'
// import rosangela1 from '/assets/artists/rosangela/rosangela1.jpg'
// import sofia1 from '/assets/artists/sofia/sofia1.jpg'
// import vico1 from '/assets/artists/vico/vico1.jpg'

export const artistsCards = [
  {
    bgImg: '/assets/artists/ana/ana1.jpg',
    artistName: 'Ana Kossoski',
    id: 'ana',
    description: 'Composição com tipos',
    audioDescription: `Composição com tipos móveis. Letras pretas muito pequenas,
    dispostas por toda folha, em 16 linhas e 18 colunas, separadas na mesma
    distância. Há uma sequência de nomes e sinais gráficos que se repetem linha a
    linha: “chove chuva chove – x –”, “chuva chove chuva – x –”, “chove chuva – x
    –”.`
  },
  {
    bgImg: '/assets/artists/camilo/camilo1.jpg',
    artistName: 'Camilo Maia',
    id: 'camilo',
    description: 'Composição com tipos',
    audioDescription: `Composição com tipos móveis. Um círculo é preenchido por um
    texto vermelho e um quadrado por um texto preto. <br /> <br />
    No círculo as palavras estão na diagonal, algumas acompanhadas de sinais
    gráficos com espaçamento entre as letras, apresentando variação de
    maiúsculas e minúsculas. “Utopia organização sonhar de baixo pra cima
    respeitar alteridade coletivizar controle empoderamento A MAIORIA DE
    TODAS AS MINORIAS para acalentar A NOSSA INDIGNAÇÃO diária e
    insubmeter a liberdade Fazer O Nunca Feito para ter o nunca TIDO, realizar o
    irrealizável; sectarismo passa a inimigo e a escuta a estratégia: // tendo O
    horizonte COMO destino // ((igualdade como prática)) ... e luta!!!”. Ele sobrepõe
    a parte inferior esquerda do quadrado. <br /> <br />
    O quadrado está no canto superior direito. Algumas palavras estão escritas em
    caixa alta e outras apenas com as iniciais em maiúscula. “Precarizar
    Verticalismo AUTORITARISMO FANATISMO IGNORÂNCIA TECNOCRACIA
    Dominar Agronegócio GENTRIFICAR INDIVIDUALISMO ELITIZAR RAIVA
    CORRUPÇÃO Moralismo Guerra CENSURA CARESTIA SUCATEMANETO
    Lucros Odiar”.`
  },
  {
    bgImg: '/assets/artists/clara/clara1.jpg',
    artistName: 'Clara Simas',
    id: 'clara',
    description: 'Composição com tipos, clichê de MDF',
    audioDescription: `Composição com tipos móveis e matriz de MDF composta de 30
    figuras vermelhas de formas irregulares e abstratas que estão organizadas em
    6 colunas e 5 fileiras ocupando toda a folha. Embaixo de cada figura, há uma
    palavra em letras minúsculas preta. A seguir, o que as figuras sugerem e as
    respectivas palavras. <br /> <br />
    <small>Um pente garfo com cinco dentes, solo; testículos, online; bolinhas tailandesas, amostra; alicate hand grip, peso; manchas arredondadas, profissionais; um bolo fecal, reais;
    vibrador com haste flexível, grotesco; vibrador com haste ondulada, público; fechadura de cabeça pra baixo, tipos; um coração, nus; uma outra mancha, rastro; um plug anal, caseiro;
    uma bola achatada, big; um ouriço, cabeludo; uma estatueta, extra; um pênis ereto, uma língua, amadores; seios com mamilos eretos, poder;
    sémen, porra; um vibrador duplo, 20min; outra mancha arredondada, troca; um vibrador com haste ereta, demo; seios com mamilos eretos; mais uma mancha arredondada, black; anel peniano, gostosxs;
    um seio com mamilo ereto, corpos; um pênis flácido, redhead; mancha arredondada com três pontas, latina; uma ducha higiênica, indoor; outro plug anal, gothic; outro vibrador duplo, bold.</small>`
  },
  {
    bgImg: '/assets/artists/daniel/daniel1.jpg',
    artistName: 'Daniel Santiago',
    id: 'daniel',
    description: 'Composição com tipos e ornamento, clichê tipográfico',
    audioDescription: `Composição com tipos móveis e clichê tipográfico. Uma
    placa quadrada acobreada com dois textos sobrepostos parcialmente, um é
    preto e o outro é branco. Ao centro, o texto preto: “Experimentando tipos em
    homenagem a’O Gráfico Amador. Experimentando tipos foi um convite a viver a
    experiência gráfica com o acervo e espírito d’O Gráfico Amador feito pelo LPG
    a artistas, designers e estudantes”. Abaixo, duas listas, com 20 nomes. A da
    direita, está de cabeça para baixo. Ao fundo, o texto branco, preenche as
    margens da placa. No topo: “1ª SESSÃO DE PINTURA FALADA DO RECIFE.
    Dia: Sábado, 24 de novembro de 1979, a partir das 10hs da manhã. Local:
    Depósito do Varejão – Rua Marques Amorim, 314, Ilha do Leite – Recife – PE”.
    Abaixo, duas listas com 64 nomes próprios em letras maiúsculas. A da direita
    está de cabeça para baixo. Mais abaixo,“Pintura falada é um quadro feito de
    acordo com a descrição dada ao pintor.” Parte das informações escritas estão
    com sobreposições de letras ou com frases de cabeça para baixo. No rodapé,
    uma assinatura em preto.`
  },
  {
    bgImg: '/assets/artists/edna/edna1.jpg',
    artistName: 'Edna Lucia Cunha Lima',
    id: 'edna',
    description: 'Composição com tipos e fios',
    audioDescription: `Composição com tipos móveis. Cinco textos pretos
    centralizados, cada um com um subtítulo em vermelho. No topo, o título
    “Garamond” está entre linhas horizontais vermelhas. O tamanho da fonte dos
    textos aumenta de forma crescente exceto o dos subtítulos. <br /> <br />
    Subtítulo 1: “3512 Corpo 12 min. ca. 5kg” <br />
    Texto 1: “As oficinas particulares de fundição de tipos começam a aparecer no
    Rio de Janeiro nas primeiras décadas do século 19. É uma fase em que a
    Imprensa oficial e as gráficas particulares costumavam comprar tipos prontos
    no exterior. Quando estudamos a fundição de tipos nem sempre encontramos
    os criadores de novos alfabetos, mas modestos artesãos que sabem como
    reproduzir matrizes muito bem.” <br /> <br />
    Subtítulo 2: “3516 Corpo 16 min. ca. 8kg” <br />
    Texto 2: “As gráficas de então, tipografias em seu sentido pleno, passam a
    depender do setor de fundição de tipos para seu funcionamento. Os catálogos
    do século 19 eram complexos, com centenas de fontes e layouts
    demonstrativos de seu uso, incluindo invariavelmente colchetes, bigodes,
    linhas e ornamentos.” <br /> <br />
    Subtítulo 3: “3520 Corpo 20 min. ca. 19kg” <br />
    Texto 3: “Júlia Augusta d’Araújo dos Santos 
    MADUREIRA / PIERRE JOSEPH PINART /
    ALEXANDRINO José das Neves / Anthony BESSEMER” <br /> <br />
    Subtítulo 4: “3524 Corpo 24 min. ca. 23kg” <br />
    Texto 4: “ISAAC BALONCHARD / EUGENIO BOUCHAUD 
    AUBERTIE / Manoel Sabino Corção / Luis Muratet” <br /> <br />
    Subtítulo 5: “3548 Corpo 48 min. ca. 28kg” <br />
    Texto 5: “Andrew Jackson Lamoureux 
    HENRIQUE ROSA”`
  },
  {
    bgImg: '/assets/artists/filipe/filipe1.jpg',
    artistName: 'Filipe Aca',
    id: 'filipe',
    description: 'Composição com tipos',
    audioDescription: `Composição com tipos móveis. A palavra “Gente” é escrita em
    preto repetidas vezes e de variadas formas, em 26 linhas. A fonte da letra
    aumenta a cada linha. Algumas estão de cabeça para baixo, acompanhadas de
    sinais gráficos e números, com variação de letras maiúsculas e minúsculas.`
  },
  {
    bgImg: '/assets/artists/isabela/isabela1.jpg',
    artistName: 'Isabela Stampanoni',
    id: 'isabela',
    description: 'Composição com tipos, fios e ornamentos; clichê de linóleo e desenho em nanquim',
    audioDescription: `Composição com tipos móveis, fios, ornamentos, matriz
    de linóleo e desenho em nanquim. Uma sequência de títulos e textos
    desalinhados em letras maiúsculas e minúsculas, acompanhado de sinais
    gráficos, todos em preto, e o desenho de um aparelho auditivo amarelo. No
    topo o título e o subtítulo: “O SOM ENTRA”, “O SOM ENTRA NO CORPO SEM
    FREIOS”. Abaixo, retas paralelas azuis incidem sobre a tuba auditiva. Um
    líquido preto passa da tuba auditiva até a parte externa da orelha. Abaixo:
    “escrevo canto aleatoriamente em qualquer lugar escuta músculo temporal
    tímpano língua limítrofe marteloossos A VOZ ritmo SONZ INTERNOS
    fonotropismo coclear estribo ritual concha sonoridade”. No canto inferior direito, assinatura de Isabela Stampanoni.`
  },
  {
    bgImg: '/assets/artists/jessica/jessica1.jpg',
    artistName: 'Jéssica Paiva',
    id: 'jessica',
    description: 'Composição com tipos, clichê de MDF',
    audioDescription: `Composição com tipos móveis e matriz de MDF. A palavra
    “ENCURRALADO” forma um quadrado com espaço branco no meio. As letras
    são grandes e maiúsculas em rosa, laranja, vermelho e amarelo. Sobre a vogal
    “O” em preto, em letras miúdas: <br /> <br />
    “encontrou <br />
    saída <br />
    nas palavras <br />
    escreveu <br />
    seu próprio <br />
    caminho”.<br /> <br />
    No canto inferior direito a assinatura de Jéssica Paiva.`
  },
  {
    bgImg: '/assets/artists/juliana/juliana1.jpg',
    artistName: 'Juliana Dias',
    id: 'juliana',
    description: 'Texto de Bráulio Bessa. Composição com tipos',
    audioDescription: `Composição com tipos móveis. Na parte superior, escrito de
    forma embaralhada, palavras na vertical, horizontal e de cabeça para baixo em
    preto. “Quando chegar para não caminho houver / nenhum lugar”. E abaixo: “/
    É hora do recomeço”. No canto inferior direito em azul: “recomece...”.`
  },
  {
    bgImg: '/assets/artists/larissa/larissa1.jpg',
    artistName: 'Larissa Constantino',
    id: 'larissa',
    description: 'Composição com tipos, clichê de linóleo',
    audioDescription: `Composição com tipos móveis e matriz de linóleo.
    Centralizado, desenho de uma baleia jubarte azul clara, nada para direita.
    Palavras desalinhadas e desfocadas, entre elas a palavra mar, repetidas
    vezes, estão sobrepostas sob a calda, acima e a frente da cabeça dela.`
  },
  {
    bgImg: '/assets/artists/mariajulia/mariajulia1.jpg',
    artistName: 'Maria Júlia Rêgo',
    id: 'mariajulia',
    description: 'Composição com tipos, carimbo',
    audioDescription: `Composição com tipos móveis e carimbo. Mão direita
    espalmada formada por uma sequência de letras e números cinzas,
    organizados em fileiras horizontais com variação de tamanho, alguns estão de
    cabeça para baixo. No meio da mão, uma rosa dos ventos verde claro. Nas
    bordas laterais, na vertical: “o mediador entre a mente e o coração”. Acima da
    mão “deve ser as&quot; e abaixo &quot;(mãos)”. No rodapé, “m.j” no canto esquerdo, e
    data: “2.19”, no direito.`
  },
  {
    bgImg: '/assets/artists/mauricio/mauricio1.jpg',
    artistName: 'Maurício Castro',
    id: 'mauricio',
    description: 'Composição com tipos, clichê de linóleo',
    audioDescription: `Composição com tipos móveis e matriz de linóleo. Uma
    paisagem composta por uma pilha alta de livros pretos e brancos em primeiro
    plano à esquerda. Ao fundo, um mar de 51 nomes próprios alinhados
    horizontalmente em cinza com contorno branco, entre eles: “James Blish, Bob
    Shaw, Karel Capek, James White, Robert Heinlein, E.C.Tubb”. O tamanho da
    fonte diminui à medida que se distancia da pilha de livros. <br /> <br />
    No alto, o céu esverdeado com nuvens compridas. Entre as nuvens um corpo
    feminino, com asas simétricas triangulares, está com os braços estendidos e
    voa em direção a uma estrela de oito pontas. Entre o céu e o horizonte em
    maiúsculo e cinza: “ARGONAUTAS”. No rodapé, a assinatura de Maurício
    Castro.`
  },
  {
    bgImg: '/assets/artists/mayra/mayra1.jpg',
    artistName: 'Mayra Melo',
    id: 'mayra',
    description: 'Composição com tipos, clichê de linóleo',
    audioDescription: `Composição com tipos móveis e matriz de linóleo. Uma pessoa
    na cor azul cai de costas em um mar esverdeado com ondas volumosas e
    peixes prateados. As pernas, com os pés em pontas, e os braços estão para
    cima e fora da água e têm contorno rajado. Entre as pernas e os braços, em
    branco sobre fundo azul: <br /> <br />
    “kíní jé olódò <br />
    yemonja ó <br />
    ki a sòrò pèléé <br />
    ìyá odó ìyá odó”. <br /> <br />
    No canto inferior direito, a assinatura.`
  },
  {
    bgImg: '/assets/artists/philippe/philippe1.jpg',
    artistName: 'Philippe Souza',
    id: 'philippe',
    description: 'Composição com tipos, clichê de linóleo',
    audioDescription: `Composição com tipos móveis e matriz de linóleo. Ilustração
    monocromática vermelha vazada do rosto de Marielle Franco. Ela tem cabelo
    black power curto, sobrancelhas pequenas, olhos amendoados e boca grande.
    Ela olha levemente para a direita. Sobre o cabelo e parte do rosto, a palavra
    “presente” em preto é escrita de variados tamanhos e posições. Sinais gráficos
    substituem algumas letras da palavra. Sobrepondo o rosto a altura da boca:
    “Marielle Franco e o motorista Anderson Gomes foram assassinados na noite
    de 14 de março de 2018. Marielle era vereadora, socióloga e ativista pelos
    direitos humanos.”`
  },
  {
    bgImg: '/assets/artists/regi/regi1.jpg',
    artistName: 'Régi Silva',
    id: 'regi',
    description: 'Composição com tipos',
    audioDescription: `Composição com tipos móveis. Distribuídas em todo papel,
    exclamações, interrogações e palavras de variados tamanhos estão
    desalinhadas, escritas em maiúsculo, minúsculo, com letras ao avesso, de
    cabeça pra baixo, na horizontal e vertical, todas em vermelho, “! balbúrdia
    ARRUAÇA! Atrito! Baderna! Alvoroço comoção CAOS ORDEM? Ruído revolta
    tumulto !desorganizando! reorganizando ENTROPIA Embate rixxa bate-boca!
    Contenda confronto briga Agitação divergência Inquietude inconformidade
    conflito DUELO questionar desacordo expressar em frente afronta ato conexão
    justiça subjetividades liberdade mudança barulho.”`
  },
  {
    bgImg: '/assets/artists/renato/renato1.jpg',
    artistName: 'Renato Valle',
    id: 'renato',
    description: 'Composição com ornamentos',
    audioDescription: `Composição com tipos móveis. Em branco, o alto relevo de uma
    cruz simétrica feita com ornamentos trançados. No centro da cruz, uma
    composição de arabescos forma um losango de onde saem as quatro hastes
    que possuem três pequenas decorações arredondadas na ponta.`
  },
  {
    bgImg: '/assets/artists/rinaldo/rinaldo1.jpg',
    artistName: 'Rinaldo Silva',
    id: 'rinaldo',
    description: 'Composição com tipos e ornamentos; clichê de PVC expandido, carimbo',
    audioDescription: `Composição com tipos móveis, matriz de PVC expandido e carimbo.
    Um retângulo preto central com desenho de uma figura humanoide. Os
    rabiscos se sobrepõem, se cruzam e duplicam a imagem. O rosto está virado
    para a direita, tem cílios avantajados, nariz e bocas grandes. Ao lado do olho
    esquerdo há um pontilhado retilíneo e do direito vários tracejados. A figura está
    com o braço direito para cima e o esquerdo pra frente, o pé direito pra frente e
    o outro pro lado. Acima, no canto direito, em vermelho: “protejooquevejo” tudo
    junto. Sobreposto ao desenho e ao fundo branco, letras maiúsculas
    acompanhado por sinais gráficos, ornamentos e números, alguns deles tortos,
    formam: “MEU TEMPO HOMEM o4061961 2019”. No rodapé, em lápis,
    assinatura: na vertical separado por sílabas, RI-NAL-DO. Ao lado de cada
    canto, tem pequenos desenhos carimbados em lilás: no canto superior
    esquerdo, um barco de papel, no direito, uma mão espalmada, no inferior
    esquerdo, o contorno de uma figura humana e no direito, uma figura rupestre
    vermelha de uma pessoa com os braços para cima e pernas abertas.`
  },
  {
    bgImg: '/assets/artists/rosangela/rosangela1.jpg',
    artistName: 'Rosângela Vieira',
    id: 'rosangela',
    description: 'Composição com tipos, clichê de barbante, carimbo',
    audioDescription: `Composição com tipos móveis, matriz de barbante e
    carimbo. Uma linha curva em forma de semicírculo com as pontas em espiral.
    Uma silhueta vermelha de um pássaro voando está carimbada, acima de cada
    espiral. Ao centro, entre os espirais, em preto: “O amor exige fé, e onde não há
    fé, não pode haver Amor.” A palavra amor é vermelha e está em maiúsculo,
    exceto a letra &quot;M&quot; tem uma cauda para a direita na última perna. No canto
    inferior direito, a assinatura.`
  },
  {
    bgImg: '/assets/artists/sofia/sofia1.jpg',
    artistName: 'Sofia L\'amour',
    id: 'sofia',
    description: 'Texto de Ana Martins Marques. Composição com tipos, clichê de MDF',
    audioDescription: `Composição com tipos móveis e matriz de MDF. Texto com
    letras muito pequenas e pretas e uma porção de sinais gráficos. O texto no
    canto esquerdo, está ao lado de duas grandes manchas azuis. Algumas
    palavras estão com letras espaçadas entre si. <br /> <br />
    “Se eu encostasse <br />
    meu ouvido <br />
    no seu peito <br />
    ouviria o tumu l t o <br />
    do mar <br />
    o alarido estridente <br />
    dos banhistas <br />
    cegos de sol <br />
    o ba q u e <br />
    das ondas <br />
    quando despen c a m <br />
    na praia <br />
    Vem <br />
    escuta <br />
    no meu peito <br />
    o silê n c i o <br />
    elem e n t a r <br />
    dos m e t a i s” <br /> <br />
    Abaixo, mais duas pequenas manchas azuis e um agrupamento de minúsculos
    sinais gráficos no canto inferior direito. Entre eles estão: dois pontos, travessão,
    vírgulas, pontos, parênteses, aspas e muitos outros.`
  },
  {
    bgImg: '/assets/artists/vico/vico1.jpg',
    artistName: 'Vico Soares',
    id: 'vico',
    description: 'Composição com tipos, estêncil, digital, desenho em nanquim',
    audioDescription: `Composição com tipos móveis, estêncil, digital e desenho em
    nanquim. No topo do papel, dois blocos de texto desbotados, postos na
    diagonal são separados por uma linha sinuosa preta. À esquerda uma mancha
    de uma pincelada grossa com a silhueta de dois dentes caninos pontudos,
    como de vampiro. À direita, um pingo vermelho sangue. As letras, na cor cinza
    clara, variam entre maiúsculas e minúsculas: “Ai que belo Seria se As pessoas
    Cuspissem seus Demônios através da arte. Rancor, Mágoa, tristeza. ÓDiO,
    Inveja, Tédio, Apatia, dor... Tudo encantado em arte”. “Não precisa matar, não
    Precisa pregar, não precisa Manipular, Não Precisa se Eleger, só precisa Fazer
    um Traço, Tocar uma nota.”`
  }
]
